export default "__VITE_ASSET__Cb8SU$ei__"